import React from 'react';
import classNames from 'classnames';
import useCallbackRef from 'hooks/useCallbackRef';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';
import FilterActionWrapper from 'router/subrouters/Dash/subrouters/Business/pages/Businesses/components/filters/FilterActionWrapper';
import { NavigationVariants } from 'models/Navigation';
import { Option } from 'models/Global';

import './SingleSelectDropdownFilter.styles.scss';

type SingleSelectDropdownFilterProps = {
  className?: string;
  variant?: NavigationVariants;
  selectedValue: string;
  triggerTitle: string;
  options: Option[];
  onChange: (value: string) => void;
};

const SingleSelectDropdownFilter: React.FC<SingleSelectDropdownFilterProps> = (
  props,
) => {
  const { className, variant, selectedValue, triggerTitle, options, onChange } =
    props;

  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>();

  const classes = classNames('single-select-dropdown-filter', className);

  return (
    <FilterActionWrapper
      ref={dropdownRef}
      className={classes}
      variant={variant}
      trigerTitle={triggerTitle}
    >
      <ul>
        {options.map(({ value, label }) => (
          <li
            key={value}
            className={classNames({ selected: selectedValue === value })}
            onClick={() => {
              dropdown.setIsOpen(false);
              onChange(value);
            }}
          >
            {label}
          </li>
        ))}
      </ul>
    </FilterActionWrapper>
  );
};

export default SingleSelectDropdownFilter;
